// Should use @visiba/std
// https://github.com/VisibaCare/visiba-cortex/pull/133
// https://github.com/VisibaCare/visiba-cortex/pull/215
export function rem(px: number): string {
	return `${px / 16}rem`;
}
